import { useDispatch, useSelector } from "react-redux";
import {
  centroCostoClearActive,
  centroCostoStartAdd,
  centroCostoStartUpdate,
} from "../../../../actions/empresa";

import { Form, Space, Tooltip } from "antd";
import { CloseBtn, FormUi, Modal, SaveBtn } from "../../../ui";
import { CentroCostoForm } from "./CentroCostoForm";
import { useEffect, useRef } from "react";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  codigo: data?.codigo || null,
  nombre: data?.nombre || null,
});
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef(null);
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    }
  }, [form, prevOpen, open]);
};
export const CentroCostoModal = ({ openModal, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { activeCentroCosto } = useSelector((state) => state.centrocosto);

  useResetFormOnCloseModal({
    form,
    openModal,
  });

  const handleSave = async (values) => {
    if (activeCentroCosto) {
      dispatch(centroCostoStartUpdate(values));
    } else {
      dispatch(centroCostoStartAdd(values));
    }
    onClose();
  };

  return (
    <Modal
      title={
        <>
          Centro de Costo
          {activeCentroCosto ? (
            <small> Editar</small>
          ) : (
            <small> Registrar</small>
          )}
        </>
      }
      centered
      maskClosable={false}
      destroyOnHidden
      open={openModal}
      onOk={handleSave}
      onCancel={onClose}
      width="40%"
      footer={[
        <Space wrap key="Opts">
          <Tooltip title="Salir" key="1">
            <CloseBtn onClick={onClose} />
          </Tooltip>
          <Tooltip title="Guardar" key="2">
            <SaveBtn htmlType="submit" form="FormCentroCosto" />
          </Tooltip>
        </Space>,
      ]}
    >
      <FormUi
        form={form}
        id="FormCentroCosto"
        name="FormCentroCosto"
        autoComplete="off"
        layout="horizontal"
        clearOnDestroy
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        handleSubmit={handleSave}
        initialValues={initialValues(activeCentroCosto)}
      >
        <CentroCostoForm />
      </FormUi>
    </Modal>
  );
};
